import { dollars } from './buildings';
import { Rng } from './rng';

/*
 * Air Force flypasts: now and then a flight of fighters coming home from a test flight passes
 * low over the airport. The tower has the notice a moment before, every runway closes for a
 * while (no landings or take-offs) and the ministry pays for the trouble; the jets go over
 * with their booms and flares (client side, purely visual). Whether and when a day has one
 * follows from the world's seed and the day alone, so nothing needs saving and the rest of the
 * world's luck is untouched.
 */

/** Chance (percent) of a flypast on a given day, from this day on (0: the first day). */
export const FLYOVER_PERCENT = 18;
export const FLYOVER_FIRST_DAY = 2;
/** The window it comes in (minutes of the day, on a five-minute mark). */
export const FLYOVER_EARLIEST = 10 * 60;
export const FLYOVER_LATEST = 17 * 60;
/** How long every runway stays closed (game minutes). */
export const FLYOVER_MINUTES = 25;
/** What the ministry pays for each runway it closes. */
export const FLYOVER_COMPENSATION = dollars(4_000);
/** People talk about it (buzz). */
export const FLYOVER_BUZZ = 60;

/**
 * The minute of the day a flypast comes over on day `day` (from 0) of the world with `seed`,
 * or -1 for none that day.
 */
export function flyoverMinute(seed: number, day: number): number {
  if (day < FLYOVER_FIRST_DAY) return -1;
  const draw = new Rng((seed ^ Math.imul(day + 1, 0x165667b1)) >>> 0);
  if (draw.int(100) >= FLYOVER_PERCENT) return -1;
  const slots = (FLYOVER_LATEST - FLYOVER_EARLIEST) / 5 + 1;
  return FLYOVER_EARLIEST + draw.int(slots) * 5;
}
